import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BTOrderListItem extends SearchModelBase {
    id: number = 0;
    closed: string = '';
    isClosed: boolean|null = null;
    status: string = '';
    orderNo: string = '';
    loadNo: string = '';
    billTo: string = '';
    originCityState: string = '';
    origin: string = '';
    departure: string| null = null;
    fromDeparture: string | null = null;
    toDeparture: string | null = null;
    departed: string = '';
    destination: string = '';
    destCityState: string = '';
    destPort: string = '';
    arrivalDate: string | null = null;
    fromArrivalDate: string | null = null;
    toArrivalDate: string | null = null;
    arrivalTime : string | null = null;
    custRefNo: string = '';
    pkgs: number = 0;
    fromPkgs: number | null = null;
    toPkgs: number| null = null;
    
    eta: string | null = null;
    fromETA: string | null = null;
    ToETA: string | null = null;

    vessel: string = '';
    mblNo: string = '';
    miscNo: string = '';
    hblNo: string = '';
    containerNo: string ='';
    invoiced: string = '';
    doNo : string = '';
    closeDate: string | null = null;
    shipper: string = '';
    cbm: number = 0;
    fromCbm: number | null = null;
    toCbm: number | null = null;
    lbs: number = 0;
    fromLbs: number | null = null;
    toLbs: number | null = null;
    lfd: string | null = null;
    fromLFD: string | null = null;
    ToLFD: string | null = null;
    pickupLoc: string ='';
    uCnee: string = '';
    bondIssuer: string = '';
    itNo: string = '';
    itDate: string|null = null;
    fromITDate: string|null = null;
    toITDate: string|null = null;
    itNo2: string = '';
    itDate2: string|null = null;
    fromITDate2: string|null = null;
    toITDate2: string|null = null;
    inBond: string | null = null;
    fromInBond: string | null = null;
    toInBond :string | null = null;
    inBond2: string | null = null;
    fromInBond2: string | null = null;
    toInBond2 :string | null = null;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    arrived: boolean = false;

    invStat: string = '';
    billStat: string = '';

    kgs: number = 0;
    cft: number = 0;
    pickupLocId: number = 0;
    originId : number = 0;
    destId: number = 0;
    billToId: number = 0;

    orderDate: string | null = null;
    fromOrderDate: string | null = null;
    toOrderDate: string | null = null;

    trType: string = ''
    trStatus:string = '';
    trStatusDesc:string = '';
    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;

    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    amsBlNo: string = '';
    isfNo: string = '';
    useAmsBlNo: boolean = false;
    useIsfNo: boolean = false;
    useAms: boolean = false;
    useIsf: boolean = false;
    chbRspCode: string = '';
    chbRspMsg: string = '';
    inbondNo: string = '';

    loadId: number = 0;
    doId: number = 0;

    availDate: string | null = null;
    fromAvailDate: string | null = null;
    toAvailDate: string | null = null;
    emptyRtn: string | null = null;
    fromEmptyRtn: string | null = null;
    toEmptyRtn: string | null = null;
    
    draft: boolean = false;
    trackingNo: string = '';
    sharedURL: string = '';
    loadingport : string = '';
    etd: string | null = null;
    fromETD: string | null = null;
    ToETD: string | null = null;
    sealNo: string = '';
    recognized: string = '';
    completed: string = '';
    mot: string = '';

    anIssuer: string ='';
    anIssuerId: number = 0;
    orderSource: string ='';
    orderSourceId: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'R', width: 30, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 2, text: 'INV', width: 40, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true,}),
        XCol.Create({ col: 3, text: 'BIL', width: 40, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Draft', width: 40, dataIndex: 'draft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'Completed', width: 70, dataIndex: 'completed', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'PRO #', width: 120, dataIndex: 'orderNo', defaultColumnFocus: true }),
        XCol.Create({ col: 7, text: 'MOT', width: 60, dataIndex: 'mot', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 8, text: 'Orchid Tracking', width: 210, dataIndex: 'trStatus'}),
        XCol.Create({ col: 9, text: 'AMS', width: 50, dataIndex: 'useAmsBlNo', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'ISF', width: 50, dataIndex: 'useIsfNo', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'iCHB', width: 40, dataIndex: 'chbRspCode', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'I/B', width: 40, dataIndex: 'inbondNo', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Load #', width: 100, dataIndex: 'loadNo'}),
        XCol.Create({ col: 14, text: 'D/O #', width: 100, dataIndex: 'doNo' }),
        XCol.Create({ col: 15, text: 'PRO Date', width: 75, dataIndex: 'orderDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date }),
        XCol.Create({ col: 16, text: 'Customer', width: 120, dataIndex: 'billTo',  }),
        XCol.Create({ col: 17, text: 'Origin City', width: 100, dataIndex: 'originCityState'}),
        XCol.Create({ col: 18, text: 'Origin', width: 120, dataIndex: 'origin'}),
        XCol.Create({ col: 19, text: 'Departure', width: 75, dataIndex: 'departure', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 20, text: 'Departed', width: 60, dataIndex: 'departed',align: XCol.XAlignType.Center, type: XCol.XCellType.Bool}),
        XCol.Create({ col: 21, text: 'Dest. City', width: 100, dataIndex: 'destCityState'}),
        XCol.Create({ col: 22, text: 'Destination', width: 120, dataIndex: 'destination'}),
        XCol.Create({ col: 23, text: 'Arrival Date', width: 80, dataIndex: 'arrivalDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 24, text: 'Arrival Time', width: 70, dataIndex: 'arrivalTime', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 25, text: 'Arrived', width: 60, dataIndex: 'arrived', align: XCol.XAlignType.Center, type: XCol.XCellType.Bool}),
        XCol.Create({ col: 26, text: 'Cust Ref. #', width: 120, dataIndex: 'custRefNo'}),
        XCol.Create({ col: 27, text: 'Packages', width: 70, dataIndex: 'pkgs', align: XCol.XAlignType.Center, type: XCol.XCellType.Double}),
        XCol.Create({ col: 28, text: 'ETA', width: 75, dataIndex: 'eta', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 29, text: 'Vessel', width: 100, dataIndex: 'vessel'}),
        XCol.Create({ col: 30, text: 'Loading Port', width: 120, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 31, text: 'ETD', width: 75, dataIndex: 'etd', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 32, text: 'MBL', width: 110, dataIndex: 'mblNo'}),
        XCol.Create({ col: 33, text: 'Misc #', width: 100, dataIndex: 'miscNo'}),
        XCol.Create({ col: 34, text: 'HBL', width: 110, dataIndex: 'hblNo'}),
        XCol.Create({ col: 35, text: 'AMS #', width: 110, dataIndex: 'amsBlNo'}),
        XCol.Create({ col: 36, text: 'ISF #', width: 110, dataIndex: 'isfNo'}),
        XCol.Create({ col: 37, text: 'Container #', width: 100, dataIndex: 'containerNo'}),
        XCol.Create({ col: 38, text: 'Seal #', width: 100, dataIndex: 'sealNo'}),
        XCol.Create({ col: 39, text: 'Shipper', width: 120, dataIndex: 'shipper'}),
        XCol.Create({ col: 40, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right,formatString: '#,##0',noNullOrEmptySearch: true}),
        XCol.Create({ col: 41, text: 'CBM', width: 80, dataIndex: 'cbm', type: XCol.XCellType.Double, align: XCol.XAlignType.Right,formatString: '#,##0.000', noNullOrEmptySearch: true}),
        XCol.Create({ col: 42, text: 'Avail. Date', width: 80, dataIndex: 'availDate',type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 43, text: 'LFD', width: 75, dataIndex: 'lfd',type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 44, text: 'EMP RTN', width: 80, dataIndex: 'emptyRtn',type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 45, text: 'OBL', width: 60, dataIndex: 'oblRcvd',align: XCol.XAlignType.Center, type: XCol.XCellType.Bool}),
        XCol.Create({ col: 46, text: 'Cust. Clear', width: 60, dataIndex: 'cClear',align: XCol.XAlignType.Center, type: XCol.XCellType.Bool}),
        XCol.Create({ col: 47, text: 'Pickup Loc', width: 120, dataIndex: 'pickupLoc'}),
        XCol.Create({ col: 48, text: 'U Cnee', width: 120, dataIndex: 'uCnee'}),
        XCol.Create({ col: 49, text: 'Bond Issuer', width: 120, dataIndex: 'bondIssuer'}),
        XCol.Create({ col: 50, text: 'IT No', width: 80, dataIndex: 'itNo'}),
        XCol.Create({ col: 51, text: 'IT Date', width: 75, dataIndex: 'itDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 52, text: 'IT No. 2', width: 80, dataIndex: 'itNo2'}),
        XCol.Create({ col: 53, text: 'IT Date 2', width: 75, dataIndex: 'itDate2', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 54, text: 'Project #', width: 100, dataIndex: 'projectNo'}),
        XCol.Create({ col: 55, text: 'Order Source', width: 120, dataIndex: 'orderSource'}),
        XCol.Create({ col: 56, text: 'A/N Issuer', width: 120, dataIndex: 'anIssuer'}),
        XCol.Create({ col: 57, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 58, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 59, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 60, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return BTOrderListItem.ExportCollection;
    };

    public static OrderBy = { orderBy: BTOrderListItem.prototype.id, orderByAscending: false };

    public static formatData(data: BTOrderListItem[]) {
        return data.map((d: BTOrderListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        u1Date: { from: 'fromU1Date', to: 'toU1Date' },
        u2Date: { from: 'fromU2Date', to: 'toU2Date' },
        arrivalDate: {from: 'fromArrivalDate', to: 'toArrivalDate'},
        departure: {from: "fromDeparture", to: 'toDeparture'},
        pkgs: {from: "fromPkgs", to: "toPkgs"},
        eta: {from: "fromETA", to: "toETA"},
        cbm: {from: "fromCbm", to: "toCbm"},
        lbs: {from: "fromLbs", to: "toLbs"},
        lfd: {from: "fromLFD", to: "toLFD"},
        itDate: {from:"fromITDate", to:"toITDate"},
        itDate2: {from:"fromITDate2", to:"toITDate2"},
        inBond: {from: "fromInBond", to: "toInBond"},
        inBond2: {from: "fromInBond2", to: "toInBond2"},
        orderDate: {from: "fromOrderDate", to:"toOrderDate"},
        availDate: {from: "fromAvailDate", to:"toAvailDate"},
        emptyRtn: {from: 'fromEmptyRtn', to: "toEmptyRtn"},
        etd: {from: "fromETD", to: "toETD"},

    }
}